export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="bg-black">
      {/* Slim title bar */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-28 lg:pt-32 pb-8">
        <p className="text-xs uppercase tracking-[0.3em] text-[#ffb700] mb-3">◆ Gallery</p>
        <h1 className="font-display text-4xl lg:text-6xl text-white leading-[0.95]">
          On stage. <span className="phoenix-text">In motion.</span>
        </h1>
      </section>

      {/* Full-page collage — slightly zoomed in, edges cropped */}
      <section
        data-testid="gallery-collage"
        className="relative w-full overflow-hidden bg-black select-none"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        style={{ WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none", userSelect: "none" }}
      >
        <picture>
          <source media="(max-width: 768px)" srcSet="/gallery/collage-mobile.jpg" />
          <img
            src="/gallery/collage.jpg"
            alt="Phoenix Dance Academy — student performances, showcases, and stage moments"
            loading="eager"
            className="block w-full h-auto select-none scale-[1.06] origin-center transition-transform duration-700 ease-out pointer-events-none"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
          />
        </picture>
        {/* Transparent overlay to further block right-click & drag on the image */}
        <div
          className="absolute inset-0"
          onContextMenu={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
          aria-hidden="true"
        />
      </section>
    </div>
  );
}
